export default __webpack_public_path__ + "a781958a4c7423cebdadace594259ad7.glb";